'use client';
import React, { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { getRegionalUrl } from '@/lib/regionalUrl';

const RelatedProductCard = ({
  slug,
  sku,
  image,
  price,
  title,
  points,
}: {
  slug: string;
  sku: string;
  image: {
    item: string;
    type: string;
  };
  price: string;
  title: string;
  points: {
    product_card_points_translations_id: {
      id: number;
      point: string;
    };
  }[];
}) => {
  const params = useParams<{ countryCode?: string }>();
  const countryCode = params?.countryCode;
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const imageSize = (type: string | null) => {
    if (type === 'image_contain' || type === 'Image Contain') {
      return 'object-contain';
    }
    if (type === 'image_cover') {
      return 'object-cover';
    }
    if (type === 'image_fill') {
      return 'object-fill';
    }
  };

  return (
    <Link
      prefetch
      href={getRegionalUrl(`/product/${slug}#sku=${sku}`, countryCode)}
    >
      <div
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="w-full relative group font-proxima_font overflow-hidden group md:h-[542px] h-[260px] flex flex-col cursor-pointer transition-all duration-200 justify-between md:hover:bg-white md:hover:shadow-md md:hover:shadow-black/30 rounded-[10px] bg-off-white pb-3 md:pb-6"
      >
        <div
          className={`w-full h-full  absolute top-0  bottom-0 left-0 right-0 overflow-hidden z-10 md:hover:border-[2px] ${
            isHovered ? 'md:border-[2px]' : ''
          }  rounded-[10px]`}
        ></div>
        <div className="flex items-center flex-col justify-start gap-2 h-full px-3 md:px-6 pt-4 md:pt-6">
          {image?.item ? (
            <div className="relative w-full aspect-square rounded-lg overflow-hidden flex items-center justify-center">
              <Image
                alt={title}
                title={title}
                width={400}
                height={400}
                quality={80}
                className={`h-full w-full ${imageSize(image?.type)}`}
                src={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/${image?.item}`}
              />
            </div>
          ) : (
            <div className="col-span-2 w-full aspect-square flex flex-col gap-1 items-center opacity-50 justify-center">
              <Image
                src={'/assets/loader/no-image.png'}
                width={200}
                height={200}
                className="w-7 h-7"
                alt="img"
              />
              <p className="font-proxima_font text-sm">No Image</p>
            </div>
          )}
          <div className="py-2 w-full h-auto flex flex-col items-center gap-1 justify-between">
            <h1 className="font-bold text-center text-black text-sm md:text-base lg:text-lg ">
              {title}
            </h1>
            <h1 className="product-price font-bold md:font-semibold text-black text-lg md:text-base">
              ${price}
            </h1>
            {/* <ul className="hidden md:block w-full pl-4 list-disc text-sm my-2 text-black text-left flex-col gap-1">
              {points?.map((item, idx) => {
                return <li key={idx}>{item?.product_card_points_id?.point}</li>;
              })}
            </ul> */}
          </div>
          <div className="flex justify-center mt-auto w-full">
            <button className="w-full py-2.5 rounded-xl font-bold text-sm lg:text-base border transition-all duration-300 bg-black text-white group-hover:opacity-80 border-black ">
              Explore
            </button>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default RelatedProductCard;
